import * as moment from "moment";
import { isGermany } from "./../services/Helpers";

export default function(value: string) {
  let format = "DD/MM/YYYY HH:mm";
  if (isGermany()) {
    format = "DD.MM.YYYY HH:mm";
  }
  if (value) {
    return moment(String(value)).format(format);
  } else {
    return value;
  }
}
